import { AVAILABLE_LANGUAGES, CURRENT_LANGUAGE, DEFAULT_LANGUAGE } from "~/utils/constants";
import { resolveUrl } from "~/utils/url/urlResolver";
import * as ApiHelper from "~/api/ApiHelper";
import { invalidateNavigationCache } from "~/Header/redux/loadNavigationEpic";

function getCurrentLanguage() {
  return AVAILABLE_LANGUAGES.includes(CURRENT_LANGUAGE) ? CURRENT_LANGUAGE : DEFAULT_LANGUAGE;
}

async function changeLanguage(code: string) {
  invalidateNavigationCache();

  // Special case - resolveUrl instead of resolveApiUrl
  const url = resolveUrl("/_s/language");

  ApiHelper.submitAsForm(
    {
      code,
    },
    url,
  );
}

export const LanguageService = {
  getCurrentLanguage,
  changeLanguage,
};
